import React, { memo, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import AOS from "aos/dist/aos";
import withStyles from '@mui/styles/withStyles';
import NavBar from "./navigation/NavBar";
import Footer from "./footer/Footer";
import "aos/dist/aos.css";
import { MycontextProvider } from "../mycontext";
import Routing from "./Routing";
import smoothScrollTop from "../../shared/functions/smoothScrollTop";
import axios from 'axios';
import { Box } from "@mui/material";

AOS.init({ once: true });
const apiUrl = process.env.REACT_APP_API_URL;
const styles = (theme) => ({
  wrapper: {
    backgroundColor: theme.palette.common.white,
    overflowX: "hidden",
  },
});

function Main(props) {
  const [selectedTab, setSelectedTab] = useState(null);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(null);
  const [isCookieRulesDialogOpen, setIsCookieRulesDialogOpen] = useState(false);
  const [data, setData]= useState([]);
  const [types, setTypes]=useState([]);
  const [fav, setFav] = useState(false);

  useEffect(() => {
    axios.get(apiUrl+'/products')
    .then(response => {
      let dt= response.data
      let dt_=[]
      let ty_=[]
      dt.map(el => 
        dt_.push(JSON.parse(el[0])))
      setData(dt_.filter(el => el.status !== 'Sold' && el.status !=='Hidden').sort((a, b) => b.num - a.num));
      dt_.map(el=> ty_.push(el.type))
      ty_=ty_.filter(function(elem, pos) {
        return ty_.indexOf(elem) === pos;
        }); 
      setTypes(ty_)
    
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    }); 

  }, []);


  const selectHome = useCallback(() => {
    smoothScrollTop();
    document.title =
      "Ehankki";
    setSelectedTab("Home");
  }, [setSelectedTab]);

  const selectBlog = useCallback(() => {
    smoothScrollTop();
    document.title = "Ehankki";
    setSelectedTab("Blog");
  }, [setSelectedTab]);
  

  const selectProduct = useCallback(() => {
    smoothScrollTop();
    document.title = "Ehankki";
    setSelectedTab("Products");
  }, [setSelectedTab]);

  const openLoginDialog = useCallback(() => {
    setDialogOpen("login");
    setIsMobileDrawerOpen(false);
  }, [setDialogOpen, setIsMobileDrawerOpen]);




  return (
    <MycontextProvider>
    <Box>
      <NavBar
        selectedTab={selectedTab}
        selectTab={setSelectedTab}
        openLoginDialog={openLoginDialog}
        data={data}
      />
 
      <Routing
        selectHome={selectHome}
        selectBlog={selectBlog}
        selectProduct={selectProduct}
        data={data}
        types={types}
        setFav={setFav}
      />

      <Footer />
    </Box>
    </MycontextProvider>
  );
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(memo(Main));
